import { BkAppType, WidgetAgent } from '@/services/AppsService/types';
import { AppServiceError } from '@/services/AppsService/Errors/AppServiceError';
import {ListVendorAppAggregateResponse, WidgetAgentResourceResponse} from "@bookingkit/api-v4";

export const fromApiApp = (app: ListVendorAppAggregateResponse): BkAppType => {
    const {
        id, active, title, description,
    } = app;
    if (id === undefined || active === undefined || title === undefined) {
        throw AppServiceError.fromMalformedResponse('id|active|title');
    }
    const resources: string[] = [];
    if(app.resources && Array.isArray(app.resources)) {
        app.resources.forEach((capability) => {
            resources.push(capability);
        })
    }
    return {
        id,
        isActive: active,
        name: title,
        description,
        resources
    };
};

export const fromApiAgent = (agent: WidgetAgentResourceResponse): WidgetAgent => {
    const { id, agent_publishable_key, agent_name, active, widget_publishable_key } = agent;
    if (!id) {
        throw AppServiceError.fromMalformedResponse('id');
    }
    if (!agent_publishable_key) {
        throw AppServiceError.fromMalformedResponse('agent_publishable_key');
    }
    return {
        id,
        agentPublishableKey: agent_publishable_key,
        agentName: agent_name,
        active,
        widgetPublishableKey: widget_publishable_key,
    };
};

export default { fromApiApp, fromApiAgent };
